/**
 * Width utility classes for a message card in the communication inbox.
 *
 * Emails render as a fixed-width reading pane (`w-[500px]`, clamped by
 * `max-w-full` so they never overflow a narrow pane). Every other modality
 * (chat, messenger, sms, mentions, call, …) keeps the original shrink-to-fit
 * chat-bubble sizing so short messages like "Hi" stay small.
 *
 * Kept as a pure function so the width behaviour can be unit-tested without
 * rendering the full (Redux/context-heavy) TextMessageBlock component.
 */
export const EMAIL_WIDTH_CLASSES = "w-[500px] max-w-full";
export const BUBBLE_WIDTH_CLASSES = "w-fit max-w-[450px]";

export const getMessageWidthClasses = (modality: string): string =>
  modality === "email" ? EMAIL_WIDTH_CLASSES : BUBBLE_WIDTH_CLASSES;
